import {
  Cancel,
  Edit,
  FiberManualRecord,
  Restore,
  Visibility,
} from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import FilterListIcon from "@mui/icons-material/FilterList";
import React, { useEffect, useState } from "react";
import { Switch } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import NotFound from "../../components/SharedModule/NotFound";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";

export default function AutomatedNotif() {
  const location = useLocation();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // *********************** create & Edit functions *************************

  const [addMainCatigory, setAddMainCatigory] = useState({
    description: "",
    name: "",
    status: "",
    type: "",
    template_id: "",
    priority: "",
    frequency: "",
    timezone: "",
    run_time: "",
    start_at: "",
    end_at: "",
    channels: [],
    max_per_hour: "",
    max_per_day: "",
    is_active: "",
    is_enabled: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  const [editNotificationId, setEditNotificationId] = useState(null);

  // templates

  const [templates, setTemplates] = useState([]);

  const getTemplates = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates`,
        { headers }
      );
      console.log(response.data.data.templates);
      setTemplates(response.data.data.templates);
    } catch (error) {
      console.log(error);
    }
  };

  // periorities

  const [periorities, setPeriorities] = useState([]);

  const getPeriorities = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-priorities`,
        { headers }
      );
      console.log(response.data.data.frequencies);
      setPeriorities(response.data.data.frequencies);
    } catch (error) {
      console.log(error);
    }
  };

  // types

  const [types, setTypes] = useState([]);

  const getTypes = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-types`,
        { headers }
      );
      console.log(response.data.data.statuses);
      setTypes(response.data.data.statuses);
      // setPeriorities(response.data.data.frequencies);
    } catch (error) {
      console.log(error);
    }
  };

  // statuses

  const [statuses, setstatuses] = useState([]);

  const getStatuses = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-statuses`,
        { headers }
      );
      console.log(response.data.data.statuses);
      setstatuses(response.data.data.statuses);
      // setPeriorities(response.data.data.frequencies);
    } catch (error) {
      console.log(error);
    }
  };

  // frequencies

  const [frequencies, setFrequencies] = useState([]);

  const getFrequencies = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-frequencies`,
        { headers }
      );
      console.log(response.data.data.frequencies);
      setFrequencies(response.data.data.frequencies);
      // setPeriorities(response.data.data.frequencies);
    } catch (error) {
      console.log(error);
    }
  };

  // modal

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      description: "",
      name: "",
      status: "",
      type: "",
      template_id: "",
      priority: "",
      frequency: "",
      timezone: "",
      run_time: "",
      start_at: "",
      end_at: "",
      channels: [],
      max_per_hour: "",
      max_per_day: "",
      is_active: "",
      is_enabled: "",
    });
    setIsEditing(false);
    setEditNotificationId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditNotificationId(null);
    setAddMainCatigory({
      description: "",
      name: "",
      status: "",
      type: "",
      template_id: "",
      priority: "",
      frequency: "",
      timezone: "",
      run_time: "",
      start_at: "",
      end_at: "",
      channels: [],
      max_per_hour: "",
      max_per_day: "",
      is_active: "",
      is_enabled: "",
    });
  };

  const channelsData = [
    { id: 1, label: "Email", value: "email" },
    { id: 2, label: "SMS", value: "sms" },
    { id: 3, label: "Push", value: "fcm" },
    { id: 4, label: "In-App Notification", value: "database" },
  ];

  // sumbit functions

  const handleEdit = async (notify) => {
    setAddMainCatigory({
      description: "",
      name: "",
      status: "",
      type: "",
      template_id: "",
      priority: "",
      frequency: "",
      timezone: "",
      run_time: "",
      start_at: "",
      end_at: "",
      channels: [],
      max_per_hour: "",
      max_per_day: "",
      is_active: "",
      is_enabled: "",
      users: "",
    });

    setTimeout(() => {
      setAddMainCatigory({
        description: notify.description || "",
        name: notify.name || "",
        status: notify.status || "",
        type: notify.type || "",
        template_id: notify.template_id || "",
        priority: notify.priority || "",
        frequency: notify.frequency || "",
        timezone: notify.timezone || "",
        run_time: notify.run_time || "",
        start_at: notify.start_at || "",
        end_at: notify.end_at || "",
        channels: notify.channels || [],
        max_per_hour: notify.max_per_hour || "",
        max_per_day: notify.max_per_day || "",
        is_active: notify.is_active ? 1 : 0,
        is_enabled: notify.enabled ? 1 : 0,
        users: notify.criteria || "",
      });
      setIsEditing(true);
      setEditNotificationId(notify.id);
      setShow(true);
    }, 0);
  };

  const handleSubmitnotify = async () => {
    const formData = new FormData();

    if (isEditing) formData.append("_method", "PUT");

    formData.append("description", addMainCatigory.description);
    formData.append("name", addMainCatigory.name);
    formData.append("status", addMainCatigory.status);
    formData.append("type", addMainCatigory.type || "");
    formData.append("template_id", addMainCatigory.template_id);
    formData.append("priority", addMainCatigory.priority);
    formData.append("frequency", addMainCatigory.frequency);
    formData.append("timezone", addMainCatigory.timezone);
    formData.append("run_time", addMainCatigory.run_time);
    formData.append("start_at", addMainCatigory.start_at);
    formData.append("end_at", addMainCatigory.end_at);
    formData.append("max_per_hour", addMainCatigory.max_per_hour);
    formData.append("max_per_day", addMainCatigory.max_per_day);
    formData.append("is_active", addMainCatigory.is_active);
    formData.append("is_enabled", addMainCatigory.is_enabled);
    addMainCatigory.channels.forEach((channel) => {
      formData.append("channels[]", channel);
    });

    const url = isEditing
      ? `${newBaseUrl}/api/portal/automated-notifications/${editNotificationId}`
      : `${newBaseUrl}/api/portal/automated-notifications`;

    // const url = `${newBaseUrl}/api/portal/automated-notifications`;

    try {
      const response = await axios.post(url, formData, { headers });
      console.log(response);
      toast.success(response.data.data.message, { autoClose: 3000 });
      handleClose();
      getAutomated();
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // ***************************** notification logs functions *********************

  const [showLogs, setShowLogs] = useState(false);

  const handleCloseLogs = () => {
    setShowLogs(false);
  };

  const [notifyLogs, setNotifyLogs] = useState([]);

  const getNotifyLogs = async (notifyId) => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/automated-notifications/${notifyId}/logs`,
        {
          headers,
        }
      );
      console.log(response.data.data.logs.data);
      setNotifyLogs(response.data.data.logs.data);
      setShowLogs(true);
    } catch (error) {
      console.log(error);
    }
  };

  const logsColumns = [
    {
      field: "Date",
      headerName: "Date",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Channel",
      headerName: "Channel",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Details",
      headerName: "Details",
      flex: 1,
      minWidth: 100,
    },
  ];

  const logsRows = notifyLogs?.map((notify) => ({
    id: notify.id,
    Status: notify.status,
    Date: formatDate(notify.created_at),
    Channel: notify.channel,
    Details: notify.title,
  }));

  // ***************************** notification preview functions *********************

  const [showPreview, setShowPreview] = useState(false);

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const [notifyData, setNotifyData] = useState(null);

  const getNotifyData = async (notifyId) => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/automated-notifications/${notifyId}`,
        {
          headers,
        }
      );
      console.log(response.data.data.notification);
      setNotifyData(response.data.data.notification);
      setShowPreview(true);
    } catch (error) {
      console.log(error);
    }
  };

  // delete

  const [notifyId, setNotifyId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setNotifyId(id);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setNotifyId(null);
  };

  const deleteNotify = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/automated-notifications/${notifyId}`,
        {
          headers,
        }
      );
      toast.warning("Notification Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      handleClosePreview();
      getAutomated();
    } catch (error) {
      toast.error("Failed To Delete This Template.");
      console.log(error.message);
    }
  };

  // ***********************************  table functions *****************************

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const [automated, setAutomated] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getAutomated = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/automated-notifications`,
        {
          headers,
        }
      );
      console.log(response.data.data.notifications);
      setAutomated(response.data.data.notifications);
    } catch (error) {
      console.log(error);
    }
  };

  const uniqueStatuses = [
    ...new Set(automated.data.map((notify) => notify.status)),
  ].filter(Boolean);

  const AutomatedColumns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Type",
      headerName: "Type",
      flex: 0.9,
      minWidth: 90,
    },
    {
      field: "Schedule",
      headerName: "Schedule",
      flex: 0.9,
      minWidth: 100,
      renderCell: (params) => {
        return <div>{params.row.Schedule ? params.row.Schedule : "-"}</div>;
      },
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 65,
    },

    {
      field: "Next",
      headerName: "Next Run",
      flex: 0.7,
      minWidth: 65,
    },
    {
      field: "Recipients",
      headerName: "Recipients",
      flex: 0.7,
      minWidth: 65,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        // toggle
        const handleToggle = async (e) => {
          e.stopPropagation();
          try {
            await axios.post(
              `https://estbn.com/EstbnNew/public/api/portal/automated-notifications/${params.row.id}/toggle`,
              {},
              { headers }
            );
            setAutomated((prev) => ({
              ...prev,
              data: prev.data.map((item) =>
                item.id === params.row.id
                  ? {
                      ...item,
                      status: item.status === "active" ? "paused" : "active",
                    }
                  : item
              ),
            }));
            toast.success("Status Toggled Successfully", { autoClose: 3000 });
          } catch (error) {
            toast.error("Toggle Error", { autoClose: 3000 });
          }
        };
        // log
        const handleLog = (event) => {
          event.stopPropagation();
          getNotifyLogs(params.row.id);
        };
        // preview
        const handlePreview = (event) => {
          event.stopPropagation();
          getNotifyData(params.row.id);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            {/* preview  */}
            <IconButton
              onClick={handlePreview}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <Visibility />
            </IconButton>
            {/* log  */}
            <IconButton
              onClick={handleLog}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <Restore />
            </IconButton>
            {/* switch */}
            <Switch
              checked={params.row.Status === "active"}
              onClick={handleToggle}
              color={params.row.Status === "active" ? "success" : "default"}
              size="small"
            />
            {/* edit  */}
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(params.row.rawData);
              }}
              color="default"
              style={{ width: "22%" }}
              aria-label="delete"
            >
              <Edit />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const filteredRows = automated.data
    .filter((notify) => {
      const matchesSearch =
        notify.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
        notify.name.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesStatus =
        selectedStatuses.length === 0 ||
        selectedStatuses.includes(notify.status);

      return matchesSearch && matchesStatus;
    })
    .map((notify) => ({
      id: notify.id,
      Name: notify.name,
      Type: notify.type,
      Schedule: notify.schedule_configq,
      Status: notify.status,
      Next: formatDate(notify.next_run_at),
      Recipients: notify.total_recipients,
      Actions: "",
      rawData: notify,
    }));

  // ******************************************* effects ****************************

  useEffect(() => {
    if (location.state?.openModal) {
      handleShow();
    }
  }, [location.state]);

  useEffect(() => {
    getAutomated();
    getPeriorities();
    getTypes();
    getStatuses();
    getFrequencies();
    getTemplates();
  }, []);

  return (
    <>
      {/* add notifctaion */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Create New Automated Notification
            {/* {isEditing ? "Edit Brand" : "Add Brand"} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleSubmitnotify)}>
            {/* Basic  */}
            <p className=" fw-semibold fs-5 my-2">Basic Information</p>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="" className="mb-2">
                  Name
                </label>
                <TextField
                  className="w-100 mb-2"
                  placeholder="Add Name"
                  variant="outlined"
                  // {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* description  */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="" className="mb-2">
                  Description
                </label>
                <TextField
                  className="w-100 mb-2"
                  placeholder="Enter Description"
                  variant="outlined"
                  rows={4}
                  multiline
                  {...register("description")}
                  value={addMainCatigory.description}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      description: e.target.value,
                    });
                  }}
                />
                {errors.description && (
                  <p className="danger">{errors.description.message}</p>
                )}
              </div>
            </div>
            {/* template */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="" className="mb-2">
                  Template
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="Template-label">Template</InputLabel>
                  <Select
                    labelId="Template-label"
                    label="Template"
                    {...register("template_id")}
                    value={addMainCatigory.template_id}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        template_id: e.target.value,
                      });
                    }}
                  >
                    {templates.map((temp) => (
                      <MenuItem className="custom-menu-item" value={temp.id}>
                        {temp.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.template_id && (
                  <p className="danger">{errors.template_id.message}</p>
                )}
              </div>
            </div>
            {/* priority */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="" className="mb-2">
                  Priority
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="Priority-label">Priority</InputLabel>
                  <Select
                    labelId="Priority-label"
                    label="Priority"
                    {...register("priority")}
                    value={addMainCatigory.priority}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        priority: e.target.value,
                      });
                    }}
                  >
                    {periorities.map((per) => (
                      <MenuItem className="custom-menu-item" value={per.value}>
                        {per.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.priority && (
                  <p className="danger">{errors.priority.message}</p>
                )}
              </div>
            </div>
            {/* status & type */}
            <div className="row">
              {/* type  */}
              <div className="col-6">
                <label htmlFor="" className="mb-2">
                  Type
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="Type-label">Type</InputLabel>
                  <Select
                    labelId="Type-label"
                    label="Type"
                    {...register("type")}
                    value={addMainCatigory.type}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        type: e.target.value,
                      });
                    }}
                  >
                    {types.map((type) => (
                      <MenuItem className="custom-menu-item" value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.type && <p className="danger">{errors.type.message}</p>}
              </div>
              {/* status  */}
              <div className="col-6">
                <label htmlFor="" className="mb-2">
                  Status
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    {statuses.map((status) => (
                      <MenuItem
                        className="custom-menu-item"
                        value={status.value}
                      >
                        {status.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* Scheduling  */}
            <p className=" fw-semibold fs-5 my-2">Scheduling</p>
            {/* frequency  */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="" className="mb-2">
                  Frequency
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="frequency-label">Daily</InputLabel>
                  <Select
                    labelId="frequency-label"
                    label="Daily"
                    {...register("frequency")}
                    value={addMainCatigory.frequency}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        frequency: e.target.value,
                      });
                    }}
                  >
                    {frequencies.map((freq) => (
                      <MenuItem className="custom-menu-item" value={freq.value}>
                        {freq.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.frequency && (
                  <p className="danger">{errors.frequency.message}</p>
                )}
              </div>
            </div>
            {/* zone & time */}
            <div className="row">
              {/* zone  */}
              <div className="col-6">
                <label htmlFor="" className="mb-2">
                  Timezone
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <InputLabel id="zone-label">Zone</InputLabel>
                  <Select
                    labelId="zone-label"
                    label="Zone"
                    {...register("timezone")}
                    value={addMainCatigory.timezone}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        timezone: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="Africa/Cairo">
                      Africa/Cairo
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="UTC">
                      UTC
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.timezone && (
                  <p className="danger">{errors.timezone.message}</p>
                )}
              </div>
              {/* time  */}
              <div className="col-6">
                <label htmlFor="" className="mb-2">
                  Time of Day
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <TextField
                    type="time"
                    value={addMainCatigory.run_time}
                    {...register("run_time")}
                    onChange={(e) =>
                      setAddMainCatigory({
                        ...addMainCatigory,
                        run_time: e.target.value,
                      })
                    }
                  />
                </FormControl>
                {errors.run_time && (
                  <p className="danger">{errors.run_time.message}</p>
                )}
              </div>
            </div>
            {/* dates */}
            <div className="w-100 d-flex justify-content-between align-items-center">
              {/* start  */}
              <div style={{ width: "47%" }} className=" mb-2">
                <TextField
                  className="w-100"
                  label="Start Date"
                  type="date"
                  value={addMainCatigory.start_at}
                  {...register("start_at")}
                  onChange={(e) =>
                    setAddMainCatigory({
                      ...addMainCatigory,
                      start_at: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              {/* end */}
              <div style={{ width: "47%" }} className=" mb-2">
                <TextField
                  className="w-100"
                  label="End Date"
                  type="date"
                  value={addMainCatigory.end_at}
                  {...register("end_at")}
                  onChange={(e) =>
                    setAddMainCatigory({
                      ...addMainCatigory,
                      end_at: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            {/* criteria  */}
            <p className=" fw-semibold fs-5 my-2">Recipient Criteria</p>
            {/* target users  */}
            <div className="col-12">
              <label htmlFor="" className="mb-2">
                Target Users
              </label>
              <TextField
                className="w-100 mb-2"
                // placeholder="Enter Description"
                variant="outlined"
                rows={4}
                multiline
                {...register("users")}
                value={addMainCatigory.users}
                onChange={(e) => {
                  setAddMainCatigory({
                    ...addMainCatigory,
                    users: e.target.value,
                  });
                }}
              />
              {errors.users && <p className="danger">{errors.users.message}</p>}
            </div>
            {/* channels  */}
            <p className=" fw-semibold fs-5 my-2">Delivery Channels</p>
            <div className="row">
              <label htmlFor="" className="mb-2">
                Select Channels
              </label>
              {channelsData.map((channel, index) => (
                <div
                  className={
                    index === channelsData.length - 1
                      ? "col-6 mb-2"
                      : "col-2 mb-2"
                  }
                  key={channel.id}
                >
                  <div className="form-check">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      id={`channel-${channel.id}`}
                      value={channel.value}
                      checked={addMainCatigory.channels.includes(channel.value)}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        let updatedChannels = [...addMainCatigory.channels];

                        if (isChecked) {
                          updatedChannels.push(channel.value);
                        } else {
                          updatedChannels = updatedChannels.filter(
                            (value) => value !== channel.value
                          );
                        }
                        setAddMainCatigory({
                          ...addMainCatigory,
                          channels: updatedChannels,
                        });
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`channel-${channel.id}`}
                    >
                      {channel.label}
                    </label>
                  </div>
                </div>
              ))}
            </div>
            {/* Rate Limits */}
            <p className=" fw-semibold fs-5 my-2">Rate Limits</p>
            {/* hour & day  */}
            <div className="row">
              {/* hour */}
              <div className="col-6">
                <label htmlFor="hour" className="mb-2">
                  Max per Hour
                </label>
                <TextField
                  type="number"
                  id="hour"
                  placeholder="Enter Number"
                  className="form-control mb-2"
                  {...register("max_per_hour")}
                  value={addMainCatigory.max_per_hour}
                  onChange={(e) =>
                    setAddMainCatigory({
                      ...addMainCatigory,
                      max_per_hour: e.target.value,
                    })
                  }
                />
                {errors.max_per_hour && (
                  <p className="danger">{errors.max_per_hour.message}</p>
                )}
              </div>
              {/* day  */}
              <div className="col-6">
                <label htmlFor="" className="mb-2">
                  Max per Day
                </label>
                <FormControl className="w-100 mb-2" variant="outlined">
                  <TextField
                    type="number"
                    placeholder="Enter Number"
                    value={addMainCatigory.max_per_day}
                    {...register("max_per_day")}
                    onChange={(e) =>
                      setAddMainCatigory({
                        ...addMainCatigory,
                        max_per_day: e.target.value,
                      })
                    }
                  />
                </FormControl>
                {errors.max_per_day && (
                  <p className="danger">{errors.max_per_day.message}</p>
                )}
              </div>
            </div>
            {/* active & enabled */}
            <p className=" fw-semibold fs-5 mb-2">Status</p>
            <div className="row">
              {/* active  */}
              <div className="col-3 mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_active"
                    checked={addMainCatigory.is_active === 1}
                    onChange={(e) =>
                      setAddMainCatigory({
                        ...addMainCatigory,
                        is_active: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="is_active">
                    Active
                  </label>
                </div>
              </div>
              {/* enabled  */}
              <div className="col-3 mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_enabled"
                    checked={addMainCatigory.is_enabled === 1}
                    onChange={(e) =>
                      setAddMainCatigory({
                        ...addMainCatigory,
                        is_enabled: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="is_enabled">
                    Enabled
                  </label>
                </div>
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* notifctaion logs */}
      <Modal show={showLogs} onHide={handleCloseLogs} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Automation Logs - Welcome Series
            <IconButton onClick={handleCloseLogs}>
              <Cancel />
            </IconButton>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {logsRows && logsRows.length > 0 ? (
              <div className="scrollable-table-wrapper">
                <div>
                  <Paper sx={{ width: "100%" }}>
                    <DataGrid
                      rows={logsRows}
                      columns={logsColumns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[5, 10]}
                      checkboxSelection
                      sx={{ border: 0 }}
                      slotProps={{
                        pagination: {
                          sx: {
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                        },
                      }}
                    />
                  </Paper>
                </div>
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center w-100"
                style={{ minHeight: "300px" }}
              >
                <NotFound
                  paragraphText={
                    "No Logs Yet. All your Notifications Logs will appear here once you get started."
                  }
                />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* notifctaion preview */}
      <Modal show={showPreview} onHide={handleClosePreview} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            Welcome New Users - Profile
            <IconButton onClick={handleClosePreview}>
              <Cancel />
            </IconButton>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-3">
          {notifyData && notifyData ? (
            <>
              {/* overview */}
              <div className="bg-white rounded-3 p-3 my-3">
                <p className="mb-4 fw-semibold fs-5">Overview</p>
                <div className="row g-3">
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1">
                      <p className="mb-1 small">Status</p>
                      <p className="my-0 fw-semibold">{notifyData.status}</p>
                    </div>
                  </div>
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1 ">
                      <p className="mb-1 small">Next Run</p>
                      <p className="my-0 fw-semibold">
                        {formatDate(notifyData.next_run_at)}
                      </p>
                    </div>
                  </div>
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1 ">
                      <p className="mb-1 small">Last Run</p>
                      <p className="my-0 fw-semibold">
                        {formatDate(notifyData.last_run_at)}
                      </p>
                    </div>
                  </div>
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1 ">
                      <p className="mb-1 small">Total Recipients</p>
                      <p className="my-0 fw-semibold">
                        {notifyData.total_recipients}
                      </p>
                    </div>
                  </div>
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1 ">
                      <p className="mb-1 small">Success Rate</p>
                      <p className="my-0 fw-semibold">
                        {notifyData.success_count}
                      </p>
                    </div>
                  </div>
                  <div className="col-4 my-2">
                    <div className="border border-1 px-3 py-2 rounded-3 m-1 ">
                      <p className="mb-1 small">Failures</p>
                      <p className="my-0 fw-semibold">
                        {notifyData.failure_count}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* schedule */}
              <div className="bg-white rounded-3 p-3 my-3">
                <p className="mb-2 fw-semibold fs-5">Schedule Details</p>
                <div className="row">
                  <div className="col-12 m-1">
                    <p className="mb-1 text-muted small">Type</p>
                    <p className="my-0 fw-semibold">{notifyData.type}</p>
                  </div>
                  <div className="col-12 m-1">
                    <p className="mb-1 text-muted small">Frequency</p>
                    <p className="my-0 fw-semibold">{notifyData.frequency}</p>
                  </div>
                  <div className="col-12 m-1">
                    <p className="mb-1 text-muted small">Channels</p>
                    <p className="my-0 fw-semibold">
                      {notifyData.channels === null ||
                      notifyData.channels.length === 0
                        ? "Undefined"
                        : notifyData.channels.map((channel, index) => (
                            <span key={index} className="me-2">
                              <FiberManualRecord sx={{ width: "10px" }} />{" "}
                              {channel}
                            </span>
                          ))}
                    </p>
                  </div>
                  <div className="col-12 m-1">
                    <p className="mb-1 text-muted small">Priority</p>
                    <p className="my-0 fw-semibold">{notifyData.priority}</p>
                  </div>
                </div>
              </div>
              {/* criteria */}
              <div className="bg-white rounded-3 p-3 my-3">
                <p className="mb-2 fw-semibold fs-5">Recipient Criteria</p>
                <div className="row">
                  <div className="col-11 mx-auto rounded-3 my-1 bg-light px-4 py-3">
                    <p className="my-0">
                      {notifyData.criteria === null
                        ? "Undefined"
                        : notifyData.criteria}
                    </p>
                  </div>
                </div>
              </div>
              {/* delete */}
              <div>
                <button
                  onClick={() => confirmDelete(notifyData.id)}
                  className="w-50 mt-2 py-2 mx-auto bg-danger text-white form-control"
                >
                  Delete
                </button>
              </div>
            </>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Data Yet. All your Notifications Data will appear here once you get started."
                }
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* delete template  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this Notification?"}
        deleteFunction={deleteNotify}
      />
      {/* notifctaion data  */}
      <div className="m-4">
        {/* notifctaion head  */}
        <div className="notifications-display d-flex justify-content-between align-items-center">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">
            Automated Notifications
          </p>
          <button
            onClick={handleShow}
            className="btn border border-1 text-muted p-2"
          >
            <i className="fa-solid fa-plus fw-light mx-1"></i>
            Add New Notification
          </button>
        </div>
        {/* notifctaion search  */}
        <div className="notif-search d-flex justify-content-center justify-content-md-end align-items-center my-3">
          {/* text search  */}
          <FormControl
            sx={{ width: "40ch" }}
            className="me-3 mx-md-3"
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Search by type, name ..
            </InputLabel>
            <OutlinedInput
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="outlined-adornment-password"
              type={"text"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">{<SearchIcon />}</IconButton>
                </InputAdornment>
              }
              label="Search by Code, name, type..."
            />
          </FormControl>
          {/* filteration  */}
          <div className="position-relative border border-1 p-2 mb-3 rounded-3">
            <IconButton onClick={() => setShowFilterDropdown((prev) => !prev)}>
              <FilterListIcon />
            </IconButton>
            {showFilterDropdown && (
              <div
                className="position-absolute mt-2 rounded shadow"
                style={{
                  width: "240px",
                  right: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  padding: "16px",
                  zIndex: 10,
                }}
              >
                <p className="fw-bold mb-2">Filter by Status</p>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {uniqueStatuses.map((status) => (
                    <label
                      key={status}
                      className="d-flex align-items-center mb-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedStatuses.includes(status)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedStatuses((prev) => [...prev, status]);
                          } else {
                            setSelectedStatuses((prev) =>
                              prev.filter((s) => s !== status)
                            );
                          }
                        }}
                      />
                      <span>{status}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* notifctaion table  */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={AutomatedColumns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Automated Notifications Yet. All your Notifications will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
